import Hls from 'hls.js'
import React, { useEffect, useRef } from 'react'

export default function Video({ guid, ...attrs }) {
  const video = useRef(null)
  const subdomain = {
    exxxotica: 'vz-e82c25a7-fcd',
    420: 'vz-6776f145-f42'
  }[process.env.GATSBY_SITE]
  const url = `https://${subdomain}.b-cdn.net/${guid}/playlist.m3u8`

  useEffect(() => {
    let first = true

    const observer = new IntersectionObserver(
      ([{ isIntersecting, target }]) => {
        if (first) {
          first = false

          return
        }

        if (isIntersecting && target.paused && target.autoplay) {
          target?.play()
        } else {
          target?.pause()
        }
      }
    )

    observer.observe(video.current)

    if (video.current.canPlayType('application/vnd.apple.mpegurl')) {
      return
    } else if (Hls.isSupported()) {
      let hls = new Hls({
        startLevel: -1,
        capLevelToPlayerSize: true,
        autoStartLoad: false,
        maxBufferSize: 1,
        maxBufferLength: 5
      })

      hls.loadSource(url)
      hls.attachMedia(video.current)
      hls.startLoad()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video ref={video} {...attrs}>
      <source src={url} type="application/vnd.apple.mpegurl" />
    </video>
  )
}
